import { alpha, keyframes, type Theme } from "@mui/material/styles";

import type { LiveRowMark } from "./useLiveListSync";

const UPDATED_CLASS = "live-row-updated";
const MOVED_CLASS = "live-row-moved";

export const liveRowClassName = (mark: LiveRowMark | undefined) => {
  if (!mark) return "";
  return mark.kind === "moved" ? MOVED_CLASS : UPDATED_CLASS;
};

export const liveRowSx = (theme: Theme) => {
  const highlight = alpha(theme.palette.primary.main, 0.16);
  const flash = keyframes`
    from { background-color: ${highlight}; }
    to { background-color: transparent; }
  `;
  return {
    [`& .${UPDATED_CLASS}`]: { animation: `${flash} 2s ease-out` },
    [`& .${MOVED_CLASS} .DataTable-cell`]: { opacity: 0.5 },
    "@media (prefers-reduced-motion: reduce)": {
      [`& .${UPDATED_CLASS}`]: {
        animation: "none",
        backgroundColor: highlight,
      },
    },
  };
};
